
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-listing",
      function () {
        return require("private-next-pages/job-listing.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job-listing"])
      });
    }
  